import React from 'react';
import { Botao, Alerta, TipoAlerta, TipoBotao, TamanhoBotao, Box } from "@intechprev/componentes-web";
import { WebRecadPublicoAlvoEntidade } from "../../entidades";
import { BuscarNome, DMN_SITUACAO_RECAD, TYP_SITUACAO_RECAD } from '../../domains';

interface Props {
  Avancar: () => void;
  Recads: WebRecadPublicoAlvoEntidade[];
  MontarDadosRecadastramento: (Recad: WebRecadPublicoAlvoEntidade) => Promise<void>;
}

interface State {
  TextoRecad: string;
  OidSelecionado: number;
  MsgMatricula: string;
  RecadSelecionado: WebRecadPublicoAlvoEntidade;
}

export class SituacaoRecad extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      TextoRecad: "Aguarde enquanto o sistema carrega sua situação no recadastramento.",
      OidSelecionado: 0,
      MsgMatricula: "",
      RecadSelecionado: null
    }
  }

  componentDidMount = async () => {
    if (this.props.Recads.length === 1) {
      const recad = this.props.Recads[0];

      this.HandleSelecionarRecad(recad);
    }
  }

  HandleSelecionarRecad = async (recad: WebRecadPublicoAlvoEntidade) => {
    if (recad.IND_SITUACAO_RECAD === DMN_SITUACAO_RECAD.AGUARDANDO || recad.IND_SITUACAO_RECAD === DMN_SITUACAO_RECAD.RECUSADO) {
      await this.props.MontarDadosRecadastramento(recad);
      this.props.Avancar();
    }
    else {
      this.setState({
        RecadSelecionado: recad,
        TextoRecad: recad.TEXTO_RECAD
      });
    }
  }

  // UNSAFE_componentWillReceiveProps() {
  //   window.location.reload();
  // }
  /*

  */

  HandleSelecionarMatricula = async () => {
    if (this.state.OidSelecionado === 0) {
      this.setState({ MsgMatricula: "Selecione a Matrícula que deseja utilizar." });
      return;
    }
    const recadSelecionado = this.props.Recads.filter(x => x.OID_RECAD_PUBLICO_ALVO === this.state.OidSelecionado);
    if (recadSelecionado.length > 0) {
      const recad = recadSelecionado[0];
      this.HandleSelecionarRecad(recad);
    }
  }

  render() {
    return (
      <div>
        {this.state.RecadSelecionado && <>
          <Alerta
            mensagem={this.state.TextoRecad}
            tipo={TipoAlerta.info}
          />
        </>}

        {this.props.Recads.length > 1 && !this.state.RecadSelecionado && <>
          <Box>
            <h4>
              {"Selecione uma matrícula/perfil para iniciar o recadastramento:"}
            </h4>

            <table className={"table table-responsive table-bordered"}>
              <thead>
                <tr>
                  <th></th>
                  <th>{"Matrícula"}</th>
                  {/* <th>{"Perfil"}</th> */}
                  <th>{"Nome da Campanha"}</th>
                  <th>{"Situação Recadastramento"}</th>
                </tr>
              </thead>
              <tbody>{this.props.Recads.map((recad: WebRecadPublicoAlvoEntidade, index: number) => {
                const selecionado = this.state.OidSelecionado === recad.OID_RECAD_PUBLICO_ALVO;

                return (
                  <tr className={(selecionado ? "table-success" : "")} key={index}>
                    <td>
                      <input
                        name={"MatriculaSelecionada"}
                        className={"m-2"}
                        value={recad.NUM_MATRICULA}
                        type={"radio"}
                        checked={selecionado}
                        onChange={() => {
                          this.setState({
                            OidSelecionado: recad.OID_RECAD_PUBLICO_ALVO
                          });
                        }}
                      />
                    </td>
                    <td>
                      {recad.NUM_MATRICULA}
                    </td>
                    {/* <td>
                      {recad.GRUPO_RECADASTRAMENTO}
                    </td> */}
                    <td>
                      {recad.NOM_CAMPANHA}
                    </td>
                    <td>
                      {BuscarNome(recad.IND_SITUACAO_RECAD as TYP_SITUACAO_RECAD)}
                    </td>
                  </tr>
                );
              })}</tbody>
            </table>

            <Alerta tipo={TipoAlerta.info} mensagem={this.state.MsgMatricula} />

            <Botao
              titulo={"Continuar"}
              className={"m-2"}
              tamanho={TamanhoBotao.pequeno}
              tipo={TipoBotao.primary}
              onClick={this.HandleSelecionarMatricula}
            />
          </Box>
        </>}
      </div>
    );
  }
}